import React, { useState } from "react";
import BaseModalAnimated from "../../components/modal/BaseModalAnimated";
import PreviewPDF from "../../components/modal/PreviewPdf";
import EvidenceUpdateModal from "../../components/modal/EvidenceUpdateModal";
import { evidencesResource } from "../../helpers/configRoutes/backend_helper";
import ConfirmDeleteModal from "../../components/modal/ConfirmDeleteModal";

const EvidencesFilesModal = ({ modal, setModal, filters, setFilters }) => {
    const [modalPrev, setModalPrev] = useState({ show: false, url: '' })
    const [modalEvidence, setModalEvidence] = useState({ show: false })
    const [modalConfirm, setModalConfirm] = useState({ show: false })

    const deleteEvidence = async () => {
        setModalConfirm({ ...modalConfirm, loading: true })
        const response = await evidencesResource('del', {}, modalConfirm.id);
        if (response.status) {
            setFilters({ ...filters })
            setModal({ show: false })
        }
        setModalConfirm({ ...modalConfirm, loading: false, show: false, id: null })
    }

    return (
        <>
            <BaseModalAnimated modal={modal} setModal={setModal}>
                <div className="flex items-center justify-center p-3 rounded-b border-slate-200">
                    <table className=" text-left border border-gray-300 shadow-lg rounded-md">
                        <thead>
                            <tr className="bg-gray-200">
                                <th className="px-4 py-2 text-gray-600 font-semibold">Name</th>
                                <th className="px-4 py-2 text-gray-600 font-semibold">Origin</th>
                                <th className="px-4 py-2 text-gray-600 font-semibold">Description</th>
                                <th className="px-4 py-2 text-gray-600 font-semibold">Date Created</th>
                                <th className="px-4 py-2 text-gray-600 font-semibold">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {modal.item?.evidences?.map((f, i) => (
                                <tr key={i} className="hover:bg-gray-100 border-b border-gray-200">
                                    <td className="px-4 py-2">{f.file_name}</td>
                                    <td className="px-4 py-2">{f.origin}</td>
                                    <td className="px-4 py-2">{f.description}</td>
                                    <td className="px-4 py-2">{f.created_at}</td>
                                    <td className="px-4 py-2">
                                        <div className=" items-center space-x-2">
                                            <button
                                                onClick={() => setModalPrev({ show: true, url: f.base64, firma: f.firma })}
                                                className="flex items-center justify-center px-5 py-2 border-r hover:bg-gray-100"
                                            >
                                                <i className="fas fa-eye"></i>
                                            </button>
                                            <button onClick={() => setModalEvidence({ show: true, item: f })} className="flex items-center justify-center px-4 py-2 border-r hover:bg-gray-100"
                                                disabled={!f.can?.update}>
                                                <i className="fas fa-pen text-gray-500"></i>
                                            </button>
                                            <button className={`flex items-center justify-center px-4 py-2 ${!f.can?.delete ? '' : 'hover:bg-gray-100'}`}
                                                onClick={() => setModalConfirm({ show: true, id: f.id })}
                                                disabled={!f.can?.delete}>
                                                <i className={`fas fa-trash ${!f.can?.delete ? 'opacity-50' : 'text-red-500'}`}></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <PreviewPDF modal={modalPrev} setModal={setModalPrev} />
            </BaseModalAnimated >
            {modalEvidence.item?.id &&
                <EvidenceUpdateModal modal={modalEvidence} setModal={setModalEvidence} filters={filters} setFilters={setFilters} modalFather={modal} setModalFather={setModal} />
            }
            <ConfirmDeleteModal modal={modalConfirm} setModal={setModalConfirm} action={deleteEvidence} />
        </>
    );
};

export default EvidencesFilesModal;
